
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign_up",
      function () {
        return require("private-next-pages/sign_up.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign_up"])
      });
    }
  